import * as React from "react";
const IinvsysLogo = (props) => (
  <svg
    width={135}
    height={53}
    viewBox="0 0 135 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_984_15602)">
      <g filter="url(#filter0_d_984_15602)">
        <path d="M0 0H40.2242V43.4535H0V0Z" fill="white" />
      </g>
      <path
        d="M13.4082 9.19226C13.4082 6.88469 15.2841 5.01404 17.5982 5.01404C19.9123 5.01404 21.7882 6.88469 21.7882 9.19226C21.7882 11.4998 19.9123 13.3705 17.5982 13.3705C15.2841 13.3705 13.4082 11.4998 13.4082 9.19226Z"
        fill="#8C8C8C"
      />
      <path d="M20 18.3843H28.38V43.4536H20V18.3843Z" fill="#8C8C8C" />
      <path
        d="M18.4355 9.19226C18.4355 6.88469 20.3115 5.01404 22.6255 5.01404C24.9396 5.01404 26.8156 6.88469 26.8156 9.19226C26.8156 11.4998 24.9396 13.3705 22.6255 13.3705C20.3115 13.3705 18.4355 11.4998 18.4355 9.19226Z"
        fill="#2A2A2A"
      />
      <g filter="url(#filter1_d_984_15602)">
        <path
          d="M42.3027 19.8683V43.4536H48.1218V34.0475C48.1218 27.8236 50.7029 24.4543 53.5188 24.4543C55.4896 24.4543 56.8975 25.5307 56.8975 28.3384V43.4536H62.7163V26.6069C62.7163 21.8805 59.6661 19.4939 55.4428 19.4939C52.3923 19.4939 49.8582 21.1786 48.1218 23.6588V19.8683H42.3027Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_d_984_15602)">
        <path
          d="M62.5703 19.8683L70.5948 43.4536H75.8508L83.8759 19.8683H78.0097L73.2231 36.2938L68.4364 19.8683H62.5703Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter3_d_984_15602)">
        <path
          d="M90.5947 19.4939C85.9956 19.4939 83.0394 22.7229 83.0394 26.373C83.0394 30.0231 85.2446 31.6609 87.8261 32.7373C90.6887 33.9539 93.739 34.3751 93.739 36.3405C93.739 38.072 92.6127 38.8676 90.829 38.8676C88.5298 38.8676 86.9342 37.2765 86.0897 34.9835L81.4434 37.4637C82.6169 40.365 85.9015 43.8279 90.829 43.8279C95.9447 43.8279 99.2293 40.2246 99.2293 35.9662C99.2293 30.9122 93.9266 29.8827 90.6887 28.7128C89.2808 28.198 88.4357 27.4492 88.4357 26.4198C88.4357 25.1095 89.4684 24.4543 90.5947 24.4543C91.9085 24.4543 93.4573 25.1095 94.5368 26.5133L98.009 23.3312C96.5543 21.0382 93.7858 19.4939 90.5947 19.4939Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter4_d_984_15602)">
        <path
          d="M96.9941 19.8683L105.582 41.9561L101.499 53H107.13L119.332 19.8683H113.513L108.351 34.6559L102.86 19.8683H96.9941Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter5_d_984_15602)">
        <path
          d="M126.164 19.4939C121.566 19.4939 118.609 22.7229 118.609 26.373C118.609 30.0231 120.815 31.6609 123.396 32.7373C126.259 33.9539 129.309 34.3751 129.309 36.3405C129.309 38.072 128.183 38.8676 126.399 38.8676C124.1 38.8676 122.504 37.2765 121.659 34.9835L117.014 37.4637C118.187 40.365 121.472 43.8279 126.399 43.8279C131.514 43.8279 134.8 40.2246 134.8 35.9662C134.8 30.9122 129.496 29.8827 126.259 28.7128C124.851 28.198 124.006 27.4492 124.006 26.4198C124.006 25.1095 125.038 24.4543 126.164 24.4543C127.479 24.4543 129.027 25.1095 130.107 26.5133L133.579 23.3312C132.125 21.0382 129.356 19.4939 126.164 19.4939Z"
          fill="white"
        />
      </g>
      <path d="M12 18.3843H20.38V43.4536H12V18.3843Z" fill="#2A2A2A" />
    </g>
    <defs>
      <filter
        id="filter0_d_984_15602"
        x={-6.8}
        y={-5.8}
        width={53.8246}
        height={57.0535}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={3.4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.129082 0 0 0 0 0.209442 0 0 0 0 0.255202 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_984_15602"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_984_15602"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_984_15602"
        x={35.5027}
        y={13.6939}
        width={34.0141}
        height={37.5597}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={3.4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.129082 0 0 0 0 0.209442 0 0 0 0 0.255202 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_984_15602"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_984_15602"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_984_15602"
        x={55.7703}
        y={14.0683}
        width={34.9047}
        height={37.1853}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={3.4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.129082 0 0 0 0 0.209442 0 0 0 0 0.255202 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_984_15602"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_984_15602"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_984_15602"
        x={74.6434}
        y={13.6939}
        width={31.3852}
        height={37.934}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={3.4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.129082 0 0 0 0 0.209442 0 0 0 0 0.255202 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_984_15602"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_984_15602"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_984_15602"
        x={90.1941}
        y={14.0683}
        width={35.9379}
        height={46.7317}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={3.4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.129082 0 0 0 0 0.209442 0 0 0 0 0.255202 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_984_15602"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_984_15602"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_984_15602"
        x={110.214}
        y={13.6939}
        width={31.3852}
        height={37.934}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={3.4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.129082 0 0 0 0 0.209442 0 0 0 0 0.255202 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_984_15602"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_984_15602"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_984_15602">
        <rect width={135} height={53} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default IinvsysLogo;
